// Locale-aware number formatting.
//
// Policy (Oct 2026): GCC/UAE business + digital products use WESTERN digits
// (0-9) in Arabic content. Emirates NBD, ADNOC, Saudi Aramco, DFM, GRI, ISSB
// all publish Arabic financial/sustainability reports with Western numerals.
// Mixing kWh / tCO2e / USD values with Eastern digits (0-9) adds cognitive
// load and breaks Excel/OCR workflows. We therefore pass through Western
// digits unchanged in BOTH languages, keeping Arabic punctuation ("،" "٪")
// where authors already type it in copy.
//
// Usage:
//   import { formatNum, formatPct } from "@/lib/numFormat";
//   formatNum(70, "ar")      → "70"
//   formatNum("$499", "ar")  → "$499"
//   formatPct(50, "ar")      → "50%"

export function toArabicDigits(input) {
  // Kept as a stable export so existing callers compile. Pass-through: we
  // intentionally no longer convert to Arabic-Indic digits.
  if (input == null) return input;
  return String(input);
}

export function formatNum(value, _lang) {
  return String(value ?? "");
}

export function formatPct(value, _lang) {
  return `${value ?? 0}%`;
}
